import {Component, OnDestroy, OnInit} from '@angular/core';
import {select} from '@ngrx/store';
import * as fromRoot from '../../../shared/reducers';
import {SetPreferencesAction} from '../../../shared/actions/preferences';
import {GenericDatatableComponent} from '../../../shared/components/generic-datatable/generic-datatable.component';
import * as fromContract from '../../../contract/reducers';

import {OrderItem} from '../../../order/models/order-item';
import {
  ChangeContractsPageSizeAction, ClearContractsAction,
  LoadContractsAction, LoadSiteContractsAction, LoadSiteSubscriptionContractsAction,
  OrderContractsByAction,
  PageContractsToAction, QuickSearchContractsAction,
  SearchContractsAction, ToggleSearchContractsAction
} from '../../actions/contracts-list';
import {ContractFilter} from '../../models/contract-filter';
import {LinkContractModalComponent} from '../../../shared/components/link-contract-modal/link-contract-modal.component';
import {DuplicateContractModalComponent} from '../../../shared/components/duplicate-contract-modal/duplicate-contract-modal.component';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'storever-sites-list',
  templateUrl: '../../../shared/components/generic-datatable/generic-datatable.component.html',
  styleUrls: ['../../../shared/components/generic-datatable/generic-datatable.component.scss']
})
export class ContractsListComponent extends GenericDatatableComponent implements OnInit, OnDestroy {
  public modalRef: BsModalRef;

  ngOnInit(): void {
    super.ngOnInit();
    this.loadDataOnChangeUrl('endDate descending', 'contract_row_size');
   // this.orderByChanged('endDate descending');
    // this.pageChanged(1);
  }

  ngOnDestroy(): void {
    this.storeRoot.dispatch(new ClearContractsAction());
    this.dataConfig.form.markAsPristine();
  }

  loadData(): void {
    if (this.activatedRoute.snapshot.routeConfig.path === 'detail/:id' ||
      this.activatedRoute.snapshot.routeConfig.path === 'detail-multi/:id/:subscriptionUuid') {
      if (this.activatedRoute.snapshot.routeConfig.path === 'detail/:id') {
        this.storeRoot.dispatch(new LoadSiteContractsAction());
      } else {
        this.storeRoot.dispatch(new LoadSiteSubscriptionContractsAction());
      }


    } else  {
      this.storeRoot.dispatch(new LoadContractsAction());
    }

  }

  storeSelect(): void {
    this.pageSize$ = this.storeRoot.pipe(select(fromRoot.selectors.getPreferencesByName, 'contract_row_size'));
    this.count$ = this.storeContract.pipe(select(fromContract.selectors.getContractCount));
    this.showFilter$ = this.storeContract.pipe(select(fromContract.selectors.getContractShowFilter));
    this.data$ = this.storeRoot.pipe(select(fromContract.selectors.getContracts));
    // let pageSizeInit = true ;
    // this.sub$ = this.pageSize$.subscribe(pageSize => {
    //   if ( pageSizeInit && pageSize) {
    //   this.storeContract.dispatch(new ChangeContractsPageSizeAction(pageSize));
    //   pageSizeInit = false;
    //   }
    // });
    // this.subscriptions.push(this.sub$);
  }

  orderByChanged(orderBy: string): void {
    this.storeContract.dispatch(new OrderContractsByAction(orderBy));
  }

  pageSizeChanged(pageSize: number): void {
    this.storeContract.dispatch(new SetPreferencesAction({ name: 'contract_row_size', value: '' + pageSize }));
    this.storeContract.dispatch(new ChangeContractsPageSizeAction(pageSize));
  }

  pageChanged(page: number): void {
    this.storeContract.dispatch(new PageContractsToAction(page));
  }

  applyFilter(filterForm: ContractFilter): void {
    this.storeContract.dispatch(new SearchContractsAction(this.filterDeleteIfNilService.flatten(filterForm)));
  }

  applyQuickFilter(query: string): void {
    this.storeContract.dispatch(new QuickSearchContractsAction(query));
  }

  toggleFilter(showFilter: boolean): void {
    this.storeContract.dispatch(new ToggleSearchContractsAction(!showFilter));
  }

  dispatchClearDataAction(): void {

    this.storeContract.dispatch(new ClearContractsAction());
  }

  dispatchToggleSelected(order: OrderItem): void {
  }

  toggleSelected(order: OrderItem): void {
  }

  // tslint:disable-next-line:no-any
  routerLink(route: string, data: any, fragment?: string): { path: string[], fragment?: string } {
    if (this.activatedRoute.snapshot.routeConfig.path === 'detail/:id') {
      if ( route === 'contractDetail' ) {
        return { path: ['/', data.companyUuid, 'contracts', 'detail', data.uuid], fragment: fragment };
      }
      if ( route === 'companyName' ) {
        return { path: ['/', 'companies', 'detail', data.companyUuid], fragment: fragment };
      }
    } else {
      if (this.activatedRoute.snapshot.routeConfig.path === 'detail-multi/:id/:subscriptionUuid') {
        return { path: ['/', data.companyUuid, 'contracts', 'detail', data.uuid], fragment: fragment };
      } else {
        return { path: ['/', this.router.url.split('?')[0].split('/')[3], 'contracts', 'detail', data.uuid], fragment: fragment };
      }
    }
  }

  disablePagination(): boolean {
    return false;
  }

  // tslint:disable-next-line:no-any
  actionButton(type: string, data?: any): void {
    if (type === 'ModalLink') {
      this.modalService.show(LinkContractModalComponent);
    } else {
      this.router.navigate([this.router.url.split('?')[0].split('/')[3], 'contracts', 'add']);
    }
  }

  showModal($event: MouseEvent, modal: any, data: any): void {// tslint:disable-line:no-any
    if (modal === 'duplicateModal') {
      const initialState = { contractForm: data, ruleForm: data.uuid, companyUuid: this.router.url.split('?')[0].split('/')[3] };
      this.modalRef = this.modalService.show(DuplicateContractModalComponent, { initialState });
    } else {
      const initialState = { contractName: data.name, contractUuid: data.uuid, productID: data.productID };
      this.modalRef = this.modalService.show(LinkContractModalComponent, { initialState });
    }
  }
}



